module.exports = __webpack_public_path__ + "static/media/tesknota-za-przyjaciolmi.42cc48ed.jpg";